export const selectors = {
  getActiveAccessLevels: state => {
    return state.loginSetup.activeAccessLevels;
  },
};
